import { render, staticRenderFns } from "./HorizontalNavbar.vue?vue&type=template&id=27340466"
import script from "./HorizontalNavbar.vue?vue&type=script&lang=js"
export * from "./HorizontalNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports